import { Component, Input, OnInit } from "@angular/core";
import { FormGroup, FormBuilder } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";
import { Group } from "src/app/shared/models/group.model";
import { AdminService } from "../../admin/admin-service";
import { StorageService } from "../../services/storage.service";

@Component({
  selector: "app-application-status",
  templateUrl: "./application-status.component.html",
  styleUrls: ["./application-status.component.scss"],
})
export class ApplicationStatusComponent implements OnInit {
  formGroup: FormGroup;
  subs: Subscription[] = [];
  profile_status: boolean;
  profile: any;
  @Input() group: Group;
  groupId: any;
  profile_reg: boolean;
  status_list: any;
  app_status: string;
  app_stat: boolean;
  constructor(
    private service: AdminService,
    private storeSvc: StorageService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private translate: TranslateService,
    private toast: ToastrService
  ) {}

  ngOnInit(): void {
    if (this.group) {
      if (this.group["toBeRespondendedBy"] === "NONE") {
        this.app_stat = true;
        this.app_status = "Application Completed";
      }
    }
  }

  getColor(status) {
    switch (status) {
      case "Submitted":
        return "#26A69A";
      case "Initiated":
        return "#008dc9";
      case "Verified":
        return "green";
      case "#4CAF50":
        return "orange";
      case "Rejected":
        return "red";
      case "Declined":
        return "red";
      case "Approved":
        return "#2196F3";
    }
  }

  status(param) {
    this.service.groupStatus(param).subscribe((response) => {
      this.status_list = response["data"];
    });
  }
}
